import styled from "styled-components";
import { Link } from "react-router-dom";

const ButtonLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #0c2d4d;
  color: white;
  padding: 16px 32px;
  border-radius: 6px;
  font-weight: 400;
  border: none;
  transition: 0.3s;

  &:hover {
    background-color: #0a243d;
  }

  @media (max-width: 768px) {
    padding: 10px 18px;
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    padding: 8px 14px;
    font-size: 0.8rem;
  }
`;

export default function ButtonOrcamento() {
  return <ButtonLink to="/contact#contact-form">Solicitar orçamento</ButtonLink>;
}